/**
 * Similar to rails index_by, converts an array of objects to a hash.
 * TODO: enforce that key is present
 * @param array The array of objects, each object must contain 'key'.
 * @param key The key to index by.
 */

function indexBy<T>(
  array: Array<T>,
  key: string | number,
): { [key in string | number]: T } {
  return array.reduce(
    (obj, item) => ({
      ...obj,
      // @ts-ignore
      [item[key]]: item,
    }),
    {},
  );
}

export default indexBy;
